module.exports = __webpack_public_path__ + "img/menuDetail9.cdf17375.png";